import { fetcher } from "utils";

export const delete__members__carts = (id: number | string): Promise<" "> => fetcher.delete(`/members/carts/${id}`);
